export default {"src":"__ASTRO_ASSET_IMAGE__ri$kC0TC__","width":128,"height":128,"format":"svg"}